import Modal from 'bootstrap/js/dist/modal';

const headerCTABtn = document.querySelector('.bh-header--buttons .wp-element-button');
if (headerCTABtn) {
    const headerCTAModal = document.querySelector('#headerCtaModal');
    if (headerCTAModal) {
        headerCTABtn.addEventListener('click', e => {
            e.preventDefault();
            const modal = new Modal(headerCTAModal);
            modal.show();
        })
    }
}


const appendLettersInSpan = (animatedFancyFonts) => {
    if (animatedFancyFonts.length > 0) {
        animatedFancyFonts.forEach(text => {
            text.innerHTML = text.textContent.replace(/\S/g, "<span class='letter'>$&</span>");
        })
    }
}

const startAnimation = text => {
    const eachLetter = text.querySelectorAll('.letter');

    eachLetter.forEach((letter, index) => {
        letter.style.animationDelay = `${(0.5 + index / 10 - .5)}s`;
    })

    text.classList.add('loaded')
}

document.addEventListener('DOMContentLoaded', () => {
    const animatedFancyFonts = document.querySelectorAll('.animated-fancy-font');
    if (animatedFancyFonts.length > 0) {
        const handleIntersection = entries => {
            entries.map((entry) => {
                if (entry.isIntersecting) {
                    startAnimation(entry.target);
                    observer.unobserve(entry.target);
                }
            });
        }

        appendLettersInSpan(animatedFancyFonts);
        const observer = new IntersectionObserver(handleIntersection, { threshold: .5 });
        animatedFancyFonts.forEach(text => observer.observe(text));
    }
})


// Swiper
import Swiper, { Navigation } from 'swiper';
import GLightbox from 'glightbox';

const gallery = document.querySelector('.wp-block-boldhomes-apartment-gallery');
if (gallery) {
    const nextEl = gallery.querySelector('.wp-block-boldhomes-apartment-gallery--arrow-next');
    const prevEl = gallery.querySelector('.wp-block-boldhomes-apartment-gallery--arrow-prev');

    const swiperGallery = new Swiper('.wp-block-boldhomes-apartment-gallery--swiper', {
        modules: [Navigation],
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints: {
            600: {
                spaceBetween: 32,
                slidesPerView: 1.5,
                spaceBetween: 64
            }
        },
        navigation: {
            nextEl: nextEl,
            prevEl: prevEl,
        },
    });

    const lightbox = GLightbox({
        touchNavigation: true,
        loop: true,
    });

    const hideImages = filterTermID => {
        const allImages = gallery.querySelectorAll('.swiper-slide');
        allImages.forEach(img => {
            const termId = img.dataset.termId;
            if (termId.includes(filterTermID)) {
                img.classList.add('glightbox')
                img.style.display = 'block'
            } else {
                img.classList.remove('glightbox')
                img.style.display = 'none'
            }
            lightbox.reload();
        })
    }

    const showAllImages = () => {
        const allImages = gallery.querySelectorAll('.swiper-slide');
        allImages.forEach(img => {
            img.classList.add('glightbox')
            img.style.display = 'block'
        })
        lightbox.reload();
    }

    const filterBtns = document.querySelectorAll('[data-filter-term]');
    const resetBtns = () => {
        filterBtns.forEach(btn => {
            btn.classList.remove('active')
        })
    }

    filterBtns.forEach(btn => {
        const filterTermID = btn.dataset.filterTerm;
        btn.addEventListener('click', () => {
            resetBtns();
            btn.classList.add('active')
            if (filterTermID == 'all') {
                showAllImages();
            } else {
                hideImages(filterTermID);
            }

            swiperGallery.update();
        })
    })
}


const initTooltips = () => {
    const shapes = document.querySelectorAll('.imp-shape');

    shapes.forEach(shape => {
        const shapeId = shape.id;
        if(boldHomesData.apartmentDataTooltip[shapeId]) {
            const tooltipId = shape.dataset.index;

            shape.classList.add(boldHomesData.apartmentDataTooltip[shapeId]['status'])
    
            const tooltip = document.querySelector(`.imp-tooltip[data-index="${tooltipId}"]`);
            const tooltipElements = tooltip.querySelectorAll('.squares-container .squares-element');
            tooltipElements.forEach(element => {
                element.innerHTML = boldHomesData.apartmentDataTooltip[shapeId]['tooltipHTML'];
            })
        }
    })
}

function waitForElementToExist(selector) {
    const intervalID = setInterval(() => {
        if (document.querySelector(selector)) {
            clearInterval(intervalID);

            initTooltips();
        }
    }, 100);
}

waitForElementToExist('.imp-shape');


//   Table modals
const imageMap = document.querySelector('#image-map-pro-4680');
imageMap.addEventListener('click', (e) => {
    if (e.target.tagName === 'polygon') {
        const shapeId = e.target.id;

        if(!e.target.classList.contains('sprzedany')) {
            makeTableAjaxCall(boldHomesData.apartmentDataTooltip[shapeId]['postID'], 'modal-apartment-content');
        }
    }
})


const askForPriceBtnsTable = document.querySelectorAll('.wp-block-boldhomes-apartment-table--ask-for-price');
const seeMoreBtnsTable = document.querySelectorAll('.wp-block-boldhomes-apartment-table--btn-more');
if (seeMoreBtnsTable.length > 0) {
    seeMoreBtnsTable.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();

            const id = btn.dataset.id;
            makeTableAjaxCall(id, 'modal-apartment-contact');
        })
    })
}

if (askForPriceBtnsTable.length > 0) {
    askForPriceBtnsTable.forEach(btn => {
        btn.addEventListener('click', e => {
            e.preventDefault();

            const id = btn.dataset.id;
            makeTableAjaxCall(id, 'modal-apartment-content');
        })
    })
}

const initModalTabs = (container) => {
    const tabs = container.querySelectorAll('.modal-btn-tab');
    const tabsPane = container.querySelectorAll('.modal-apartment-tab-pane')
    tabs.forEach(tab => {
        tab.addEventListener('click', () => {
            const target = tab.dataset.target;

            tabsPane.forEach(tabPane => {
                tabPane.classList.remove('active')
            })

            const targetHtml = container.querySelector(`.${target}`);
            targetHtml.classList.add('active')
        })
    })
}

const initFormSubmision = form => {
    form.addEventListener('submit', e => {
        e.preventDefault();
        e.stopPropagation();

        if (form.checkValidity()) {
            const spinner = form.parentElement.querySelector('.spinner');
            spinner.classList.add('active')
            form.classList.add('submited')

            const formResponseDiv = form.querySelector('.form-response');
            const formData = new FormData(form);
            const bodyParams = new URLSearchParams();

            for (let [name, value] of formData) {
                if (value !== '') {
                    bodyParams.append(name, value)
                }
            }

            bodyParams.append('action', 'bh_send_email');
            bodyParams.append('ajaxNonce', boldHomesData.ajaxnonce);

            fetch(boldHomesData.ajaxurl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: bodyParams
            }).then(response => {
                return response.json()
            }).then(response => {
                form.classList.remove('submited')
                spinner.classList.remove('active')
                if (response.success) {
                    formResponseDiv.classList.add('success');
                    formResponseDiv.innerHTML = 'Wiadomość została wysłana. Odpowiemy najszybciej jak to możliwe';
                } else {
                    formResponseDiv.classList.add('failed');
                    formResponseDiv.innerHTML = 'Niestety nie udało się wysłać wiadomości. Prosimy o wybranie innej metody kontaktu.';
                }
            }).catch((error) => console.log(error));
        }
    })
}

const makeTableAjaxCall = (id, activeTabPane) => {
    const bodyParams = new URLSearchParams();
    bodyParams.append('action', 'bh_table_modal');
    bodyParams.append('ajaxNonce', boldHomesData.ajaxnonce);
    bodyParams.append('apartment_id', id);

    console.log(id)

    fetch(boldHomesData.ajaxurl, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'Cache-Control': 'no-cache',
        },
        body: bodyParams
    }).then(response => {
        return response.json()
    }).then(response => {
        console.log(response)

        const tableModalContainer = document.querySelector('#wp-block-boldhomes-apartment-table--modal');
        tableModalContainer.innerHTML = response.data.modal;

        const activeTab = tableModalContainer.querySelector(`.${activeTabPane}`).classList.add('active');
        initModalTabs(tableModalContainer);

        const form = tableModalContainer.querySelector('form');
        initFormSubmision(form);

        const modalHtml = tableModalContainer.querySelector('.modal');
        const modal = new Modal(modalHtml);
        modal.show();

        modalHtml.addEventListener('hidden.bs.modal', () => {
            modal.dispose();
            tableModalContainer.innerHTML = '';
        })

    }).catch((error) => console.log(error));
}